// src/ecrans/reglages/OngletConnexions.jsx — « Connexions » (maquette v677,
// relevé 269). Seules deux choses ont une source : la synchro des plateformes
// et les interrupteurs du serveur. Le reste vaut « — », jamais « fonctionne »
// sans preuve (REGLES 72). « Réglé sur le serveur, pas depuis l'écran. »

import { LienAncienG3, COULEURS as C } from "../nest-g3";

const SERVICES = [
  ["Airbnb", "réservations, calendrier, prix, messages"],
  ["Booking", "réservations, calendrier, prix"],
  ["PriceLabs", "calcule les prix du jour ; l'application est la seule à les envoyer aux plateformes"],
  ["Paiements (Stripe)", "paiements en direct et cautions"],
  ["Courriels", "mails aux voyageurs et aux propriétaires, factures"],
  ["Nuki", "serrures et codes d'accès de certains logements"],
];

/** « 30 oct. à 09:12 » à l'heure de Paris ; null si illisible. */
export function heurePreuve(iso) {
  const t = Date.parse(iso || "");
  if (Number.isNaN(t)) return null;
  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Paris",
  }).format(t);
}

function Etat({ texte, vert }) {
  return (
    <span style={{ fontSize: 10.5, fontWeight: 700, borderRadius: 7, padding: "3px 8px", flexShrink: 0, background: vert ? C.vertP : "#F2F4F3", color: vert ? C.vertF : C.gris }}>
      {texte}
    </span>
  );
}

export default function OngletConnexions({ connexions, onAncien }) {
  const preuve = heurePreuve(connexions.preuve_plateformes);
  const envois = connexions.envois_reels;
  const lignes = [
    ["Envoi des prix, règles et blocages aux plateformes", "ce qui part arrive vraiment sur Airbnb et Booking", envois.plateformes],
    ["Messages automatiques", "ce qui part arrive vraiment aux voyageurs", envois.messages],
  ];
  return (
    <>
      <p className="g3-etat">Envois réels vers les plateformes : réglé sur le serveur, pas depuis l'écran.</p>
      <p className="g3-inter">Les services</p>
      {SERVICES.map(([nom, detail], i) => {
        const plateforme = i < 2;
        const s = plateforme && preuve ? `${detail} · preuve ${preuve}` : detail;
        return (
          <div className="g3-ligne" style={{ cursor: "default" }} key={nom} data-testid="connexion-service">
            <span className="co">
              <span className="t">{nom}</span>
              <span className="s">{s}</span>
            </span>
            <Etat texte={plateforme && preuve ? "dernière synchro" : "—"} vert={plateforme && Boolean(preuve)} />
          </div>
        );
      })}
      <p className="g3-inter">Ce qui part pour de vrai</p>
      {lignes.map(([t, s, reel]) => (
        <div className="g3-ligne" style={{ cursor: "default" }} key={t} data-testid="connexion-envoi">
          <span className="co">
            <span className="t">{t}</span>
            <span className="s">{s}</span>
          </span>
          <Etat texte={reel ? "RÉEL" : "SIMULÉ"} vert={reel} />
        </div>
      ))}
      {!envois.messages ? (
        <p className="g3-etat" data-testid="connexion-simule">
          Même en simulé, les courriels transactionnels du direct partent toujours.
        </p>
      ) : null}
      <p style={{ marginTop: 12 }}>
        <LienAncienG3 pour="la connexion aux plateformes" onClick={() => onAncien("beds24")} testId="connexions-ancien" />
      </p>
    </>
  );
}
